import FilePreview from "features/FolderManager/components/FilePreview";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DashboardTV from "./DashboardTV";
import { Loader } from "semantic-ui-react";
import { stopDashboardToDualScreen } from "services/dualScreen";
import PatientInfo from "./PatientInfo";
import bionextLogo from "../../assets/image/logo-bionextlab.svg";
import { isJson } from "utils/json";

const styles = {
	centered: {
		height: "100vh",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
};

const DualScreen = () => {
	const [files, setFiles] = useState([]);
	const [dashboard, setDashboard] = useState(null);
	const [patient, setPatient] = useState(null);
	const dispatch = useDispatch();

	useEffect(() => {
		if (navigator.presentation.receiver) {
			navigator.presentation.receiver.connectionList.then((list) => {
				list.connections.forEach((connection) => {
					connection.onclose = () => {};
					connection.onterminate = () => {};
					connection.onmessage = (event) => {
						if (event.data && isJson(event.data)) {
							let data = JSON.parse(event.data);
							if (data.type === "files" && data.role === "secretary" && data.files) setFiles(data.files);
							if (data.type === "dashboard" && data.role === "secretary") {
								setDashboard(data.stats);
							}
							if (data.type === "patient") {
								setPatient(data.patient);
							}
						}

						connection.send("Received message");
					};
				});
			});
		}
	}, []);

	const closeDashboard = () => {
		dispatch(stopDashboardToDualScreen());
		setDashboard(null);
	};

	return (
		<div style={styles.centered}>
			{!dashboard && (!files || files.length === 0) && !!patient && <PatientInfo patient={patient} />}
			{!dashboard && !files && !patient && <Loader active inline="centered" />}
			{!patient && dashboard && dashboard.payload && <DashboardTV stats={dashboard.payload.data} onClose={closeDashboard} />}
			{!dashboard && !patient && (!files || files.length === 0) && (
				<div>
					<img src={bionextLogo} alt="Logo de BioneXt Lab" height="100vh" />
				</div>
			)}
			{!dashboard && !patient && files?.length > 0 && <FilePreview files={files} isModal={true} disabled={false} />}
		</div>
	);
};

export default DualScreen;
